import type { Notification } from '~/shared/types/notification.js'

/**
 * Generate a URL for a notification
 * This will create a deep link to the relevant page based on linkType and linkTarget
 *
 * @param notification The notification to generate a URL for
 * @returns URL string that the user can click on to view the related content
 */
export function generateNotificationUrl(notification: Notification): string {
  const baseUrl = window.location.origin

  switch (notification.linkType) {
    case 'task':
      return `${baseUrl}/`
    case 'subkrewe':
      return `${baseUrl}/subkrewe`
    case 'member':
      return `${baseUrl}/`
    case 'url':
      // For external URLs, just return the target directly
      return notification.linkTarget || baseUrl
    default:
      // For 'none' or undefined, just link to the notifications page
      return `${baseUrl}/notifications`
  }
}
